/** BFP-520 — initial 12 cards, append 24 per load (US-SML-1-26). */
export const SENSEMAKER_INITIAL_VISIBLE = 12
export const SENSEMAKER_LOAD_MORE_STEP = 24

export function getVisibleSensemakerCount(
  totalFiltered: number,
  visibleLimit: number,
): number {
  return Math.min(totalFiltered, visibleLimit)
}

export function canLoadMoreSensemakers(
  totalFiltered: number,
  visibleLimit: number,
): boolean {
  return visibleLimit < totalFiltered
}

export function nextSensemakerVisibleLimit(current: number): number {
  return current + SENSEMAKER_LOAD_MORE_STEP
}

export function sliceVisibleSensemakers<T>(items: T[], visibleLimit: number): T[] {
  return items.slice(0, visibleLimit)
}
